module.exports = __webpack_public_path__ + "static/media/pyramids.49eae914.png";